export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
};

export type AvvData = {
  __typename?: 'AVVData';
  /** Federal state (Bundesland) for data protection officer */
  bundesland?: Maybe<Scalars['String']['output']>;
  /** Official company name */
  kundenname?: Maybe<Scalars['String']['output']>;
  /** Person with authority to give instructions */
  weisungsbefugter?: Maybe<Scalars['String']['output']>;
};

export type AvvDataInput = {
  /** Federal state (Bundesland) for data protection officer */
  bundesland: Scalars['String']['input'];
  /** Official company name */
  kundenname: Scalars['String']['input'];
  /** Person with authority to give instructions */
  weisungsbefugter: Scalars['String']['input'];
};

export type AvvResponse = {
  __typename?: 'AVVResponse';
  /** Error message (if unsuccessful) */
  error?: Maybe<Scalars['String']['output']>;
  /** Generated AVV document details (if successful) */
  result?: Maybe<AvvResult>;
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type AvvResult = {
  __typename?: 'AVVResult';
  /** URL to download the generated AVV PDF */
  downloadUrl: Scalars['String']['output'];
  /** Name of the generated PDF file */
  fileName: Scalars['String']['output'];
  /** Unique identifier for the AVV document */
  id: Scalars['String']['output'];
};

export type AvvStats = {
  __typename?: 'AVVStats';
  /** Number of AVV documents generated this month */
  generatedThisMonth: Scalars['Int']['output'];
  /** Number of AVV documents generated this week */
  generatedThisWeek: Scalars['Int']['output'];
  /** Number of AVV documents generated today */
  generatedToday: Scalars['Int']['output'];
  /** When the last AVV document was generated (ISO string) */
  lastGenerated?: Maybe<Scalars['String']['output']>;
  /** Total number of AVV documents generated by the company */
  totalGenerated: Scalars['Int']['output'];
};

/** Input for acknowledging a notification */
export type AcknowledgeNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type ActiveAvvResult = {
  __typename?: 'ActiveAVVResult';
  /** The data used to generate the AVV */
  data?: Maybe<AvvData>;
  /** Name of the generated PDF file */
  fileName?: Maybe<Scalars['String']['output']>;
  /** When the AVV document was generated (ISO string) */
  generatedAt?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the AVV document */
  id?: Maybe<Scalars['String']['output']>;
};

/** Input for adding a document update item */
export type AddDocumentUpdateInput = {
  /** NEW, UPDATE, DELETE, or AMENDMENT */
  actionType: Scalars['String']['input'];
  bumpType?: InputMaybe<BumpType>;
  category?: InputMaybe<Scalars['String']['input']>;
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** For UPDATE/DELETE: target document ID */
  documentId?: InputMaybe<Scalars['String']['input']>;
  documentType?: InputMaybe<Scalars['String']['input']>;
  ingestionConfig?: InputMaybe<Scalars['JSON']['input']>;
  jurisdiction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** For UPDATE: previous version ID */
  previousDocumentId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  vaultPath?: InputMaybe<Scalars['String']['input']>;
};

/** Input for adding a document to an update draft */
export type AddDraftDocumentInput = {
  actionType: DraftDocumentAction;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: OfficialDocumentType;
  externalLink?: InputMaybe<Scalars['String']['input']>;
  hoverTitle?: InputMaybe<Scalars['String']['input']>;
  ingestionConfig: Scalars['JSON']['input'];
  jurisdiction: OfficialDocumentJurisdictions;
  name: Scalars['String']['input'];
  parentDocumentId?: InputMaybe<Scalars['String']['input']>;
  pdfUrl?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  relationshipType: DocumentRelationshipType;
  replacesDocumentId?: InputMaybe<Scalars['String']['input']>;
  rootUrl?: InputMaybe<Scalars['String']['input']>;
  sourcePageUrl?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<DocumentSourceType>;
  vaultPath: Scalars['String']['input'];
};

/** Input for adding a system announcement */
export type AddSystemAnnouncementInput = {
  actionRequired?: InputMaybe<Scalars['String']['input']>;
  affectedServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** MAINTENANCE, FEATURE, SECURITY, GENERAL */
  announcementType?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

/** Input for adding an item to an update */
export type AddUpdateItemInput = {
  bumpType?: InputMaybe<BumpType>;
  changeSummary?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  itemData?: InputMaybe<Scalars['JSON']['input']>;
  itemType: UpdateItemType;
  previousDocumentId?: InputMaybe<Scalars['String']['input']>;
  vaultPath?: InputMaybe<Scalars['String']['input']>;
};

/** Company-Daten für Admin-Interface */
export type AdminCompany = AdminNode & {
  __typename?: 'AdminCompany';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Firmenname */
  name: Scalars['String']['output'];
  /** E-Mail des Firmeninhabers */
  ownerEmail?: Maybe<Scalars['String']['output']>;
  /** ID des Firmeninhabers */
  ownerId: Scalars['String']['output'];
  /** Anzahl L-Plätze */
  seatsL?: Maybe<Scalars['Int']['output']>;
  /** Anzahl M-Plätze */
  seatsM?: Maybe<Scalars['Int']['output']>;
  /** Anzahl S-Plätze */
  seatsS?: Maybe<Scalars['Int']['output']>;
  /** Status des Abonnements */
  subscriptionState?: Maybe<Scalars['String']['output']>;
  /** Anzahl aktiver Nutzer */
  userCount?: Maybe<Scalars['Int']['output']>;
};

/** Paginierte Liste von AdminCompany für Admin */
export type AdminCompanyConnection = {
  __typename?: 'AdminCompanyConnection';
  /** Liste der Knoten mit Cursors */
  edges: Array<AdminCompanyEdge>;
  /** Paginierungs-Informationen */
  pageInfo: AdminPageInfo;
};

/** Edge für AdminCompany in Admin-Listen */
export type AdminCompanyEdge = {
  __typename?: 'AdminCompanyEdge';
  /** Cursor für diese Position */
  cursor: Scalars['String']['output'];
  node: AdminCompany;
};

/** Filter für Company-Listen im Admin */
export type AdminCompanyFilterInput = {
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nur Companies mit aktivem Abonnement */
  hasActiveSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Suche in Name, Owner-E-Mail oder Company-ID */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter nach Abonnement-Status */
  subscriptionStates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Sortierfelder für Company-Listen */
export enum AdminCompanySortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UserCount = 'USER_COUNT'
}

/** Sortierung für Company-Listen */
export type AdminCompanySortInput = {
  field?: AdminCompanySortField;
  order?: AdminSortOrder;
};

/** Content Node für Admin-Interface */
export type AdminContentNode = {
  __typename?: 'AdminContentNode';
  /** Anzahl der Kindknoten */
  childrenCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Referenz des zugehörigen Dokuments */
  documentReference?: Maybe<Scalars['String']['output']>;
  /** Hat der Node Kinder? */
  hasChildren?: Maybe<Scalars['Boolean']['output']>;
  /** Hover-Titel des Content Nodes */
  hoverTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Kann als Prompt verwendet werden */
  isPromptable: Scalars['Boolean']['output'];
  /** Kann vom Nutzer eingesehen werden */
  isViewable: Scalars['Boolean']['output'];
  /** Zusätzliche Metadaten des Content Nodes */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Name des Content Nodes */
  name?: Maybe<Scalars['String']['output']>;
  /** ID des übergeordneten Nodes */
  parentNodeId?: Maybe<Scalars['String']['output']>;
  /** Größe in Seiten */
  sizeInPages: Scalars['Int']['output'];
  /** Größe in Tokens */
  sizeInTokens: Scalars['Int']['output'];
  /** Voller Text des Content Nodes (nur auf Anfrage laden) */
  text?: Maybe<Scalars['String']['output']>;
  /** Kurze Vorschau des Textes (erste 200 Zeichen) - wird bei Bedarf geladen */
  textPreview?: Maybe<Scalars['String']['output']>;
  /** Typ des Content Nodes */
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Paginierte Liste von AdminContentNode für Admin */
export type AdminContentNodeConnection = {
  __typename?: 'AdminContentNodeConnection';
  /** Liste der Knoten mit Cursors */
  edges: Array<AdminContentNodeEdge>;
  /** Paginierungs-Informationen */
  pageInfo: AdminPageInfo;
};

/** Edge für AdminContentNode in Admin-Listen */
export type AdminContentNodeEdge = {
  __typename?: 'AdminContentNodeEdge';
  /** Cursor für diese Position */
  cursor: Scalars['String']['output'];
  node: AdminContentNode;
};

/** Filter für Content Node-Listen im Admin */
export type AdminContentNodeFilterInput = {
  /** Nur Nodes mit Kindknoten */
  hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nur Nodes mit übergeordnetem Node */
  hasParent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nur promptbare Nodes */
  isPromptable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nur viewable Nodes */
  isViewable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Suche in Name oder Text */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter nach Content Node-Typen */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Sortierfelder für Content Node-Listen */
export enum AdminContentNodeSortField {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  SizeInPages = 'SIZE_IN_PAGES',
  SizeInTokens = 'SIZE_IN_TOKENS',
  Type = 'TYPE'
}

/** Sortierung für Content Node-Listen */
export type AdminContentNodeSortInput = {
  field?: AdminContentNodeSortField;
  order?: AdminSortOrder;
};

export type AdminDashboardStats = {
  __typename?: 'AdminDashboardStats';
  /** Admin token TTL in minutes */
  adminTokenTtlMinutes: Scalars['Int']['output'];
  /** Number of chats created today */
  chatsCreatedToday: Scalars['Int']['output'];
  /** Number of companies created today */
  companiesCreatedToday: Scalars['Int']['output'];
  /** Database connection status */
  databaseHealthy: Scalars['Boolean']['output'];
  /** Current environment (production, development, etc.) */
  environment: Scalars['String']['output'];
  /** When these stats were last calculated */
  lastUpdated: Scalars['DateTime']['output'];
  /** Number of messages sent today */
  messagesToday: Scalars['Int']['output'];
  /** Current system health status */
  systemHealth: Scalars['String']['output'];
  /** System uptime in minutes */
  systemUptimeMinutes: Scalars['Int']['output'];
  /** Total number of chats created */
  totalChats: Scalars['Int']['output'];
  /** Total number of companies on the platform */
  totalCompanies: Scalars['Int']['output'];
  /** Total number of messages sent */
  totalMessages: Scalars['Int']['output'];
  /** Total number of users across all companies */
  totalUsers: Scalars['Int']['output'];
  /** Number of users created today */
  usersCreatedToday: Scalars['Int']['output'];
};

/** Document-Daten für Admin-Interface */
export type AdminDocument = AdminNode & {
  __typename?: 'AdminDocument';
  /** Anzahl der Änderungsdokumente */
  amendedByCount?: Maybe<Scalars['Int']['output']>;
  /** Dokument, das geändert wird */
  amendsDocument?: Maybe<AdminDocument>;
  /** ID des geänderten Dokuments */
  amendsDocumentId?: Maybe<Scalars['String']['output']>;
  /** Referenz des geänderten Dokuments */
  amendsDocumentReference?: Maybe<Scalars['String']['output']>;
  /** Kategorie des Dokuments */
  category?: Maybe<Scalars['String']['output']>;
  /** Konsolidierungsdatum */
  consolidationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Anzahl der Content Nodes */
  contentNodeCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Zeitpunkt der Löschung (wenn soft-deleted) */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Beschreibung des Dokuments */
  description?: Maybe<Scalars['String']['output']>;
  /** Inkrafttreten */
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  /** Seiten mit Erklärungen */
  explanationPages?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Externer Link zum Dokument */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** Gruppenname für verwandte Dokumente */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Hover-Titel für das Dokument */
  hoverTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Seiten mit Bildern */
  imagePages?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Ist das Dokument aktiv? */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Rechtsgebiet (EU, DE, OTHER) */
  jurisdiction: Scalars['String']['output'];
  /** Zeitpunkt der letzten Synchronisation */
  lastSyncAt?: Maybe<Scalars['DateTime']['output']>;
  /** Name des Dokuments */
  name: Scalars['String']['output'];
  /** Offizielle Versionsnummer */
  officialVersion?: Maybe<Scalars['String']['output']>;
  /** URL zur PDF-Version des Dokuments */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Zeitpunkt der endgültigen Löschung */
  purgedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Eindeutige Referenz (z.B. "CSRD Art. 1-3") */
  reference: Scalars['String']['output'];
  /** Aufhebungsdatum */
  repealedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Anzahl der Wiederholungsversuche */
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Root-URL der Website/Quelle */
  rootUrl?: Maybe<Scalars['String']['output']>;
  /** URL der Originalseite, auf der das Dokument gefunden wurde */
  sourcePageUrl?: Maybe<Scalars['String']['output']>;
  /** Quelle des Dokuments (LOCAL, ONLINE, etc.) */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** Letzter Synchronisationsfehler */
  syncError?: Maybe<Scalars['String']['output']>;
  /** Synchronisationsstatus */
  syncStatus?: Maybe<Scalars['String']['output']>;
  /** Seiten mit Tabellen */
  tablePages?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** Summe aller Seiten der Content Nodes */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** Summe aller Tokens der Content Nodes */
  totalTokens?: Maybe<Scalars['Int']['output']>;
  /** Dokumenttyp (LAW, REGULATION, DIRECTIVE, etc.) */
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  /** Hauptversion */
  versionMajor: Scalars['Int']['output'];
  /** Nebenversion */
  versionMinor: Scalars['Int']['output'];
};

/** Paginierte Liste von AdminDocument für Admin */
export type AdminDocumentConnection = {
  __typename?: 'AdminDocumentConnection';
  /** Liste der Knoten mit Cursors */
  edges: Array<AdminDocumentEdge>;
  /** Paginierungs-Informationen */
  pageInfo: AdminPageInfo;
};

/** Edge für AdminDocument in Admin-Listen */
export type AdminDocumentEdge = {
  __typename?: 'AdminDocumentEdge';
  /** Cursor für diese Position */
  cursor: Scalars['String']['output'];
  node: AdminDocument;
};

/** Filter für Document-Listen im Admin */
export type AdminDocumentFilterInput = {
  /** Filter für Dokumente die ein bestimmtes Dokument ändern */
  amendsDocument?: InputMaybe<Scalars['String']['input']>;
  /** Filter nach Kategorien */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Nur Dokumente mit Änderungen */
  hasAmendments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nur aktive (nicht gelöschte) Dokumente */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter nach Rechtsgebieten */
  jurisdictions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Maximale Anzahl Tokens */
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Mindestanzahl Tokens */
  minTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Filter für Dokumente die zu einem bestimmten Dokument in Beziehung stehen (Amendments, etc.) */
  relatedToDocument?: InputMaybe<Scalars['String']['input']>;
  /** Suche in Name, Referenz oder Beschreibung */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Zeige alle Dokumente (aktive und gelöschte) */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter für ein spezifisches Dokument anhand der ID */
  specificDocument?: InputMaybe<Scalars['String']['input']>;
  /** Filter nach Dokumenttypen */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Aggregated metrics for all documents in the system */
export type AdminDocumentMetrics = {
  __typename?: 'AdminDocumentMetrics';
  /** Number of documents that have amendments */
  documentsWithAmendments: Scalars['Int']['output'];
  /** Document count by jurisdiction */
  jurisdictionBreakdown: Array<AdminDocumentMetricsJurisdictionStat>;
  /** Top 5 documents by content node count */
  largestDocuments: Array<AdminDocumentMetricsLargestDocument>;
  /** When these metrics were calculated */
  lastCalculated: Scalars['DateTime']['output'];
  /** Number of documents created in the last 30 days */
  recentDocuments: Scalars['Int']['output'];
  /** Total number of active content nodes */
  totalContentNodes: Scalars['Int']['output'];
  /** Total number of active documents */
  totalDocuments: Scalars['Int']['output'];
  /** Total page count across all content nodes */
  totalPages: Scalars['Int']['output'];
  /** Total token count across all content nodes */
  totalTokens: Scalars['Int']['output'];
  /** Document count by type */
  typeBreakdown: Array<AdminDocumentMetricsTypeStat>;
};

export type AdminDocumentMetricsJurisdictionStat = {
  __typename?: 'AdminDocumentMetricsJurisdictionStat';
  count: Scalars['Int']['output'];
  jurisdiction: Scalars['String']['output'];
};

export type AdminDocumentMetricsLargestDocument = {
  __typename?: 'AdminDocumentMetricsLargestDocument';
  contentNodeCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
};

export type AdminDocumentMetricsTypeStat = {
  __typename?: 'AdminDocumentMetricsTypeStat';
  count: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

/** Sortierfelder für Document-Listen */
export enum AdminDocumentSortField {
  ContentNodeCount = 'CONTENT_NODE_COUNT',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Reference = 'REFERENCE',
  TotalTokens = 'TOTAL_TOKENS',
  UpdatedAt = 'UPDATED_AT'
}

/** Sortierung für Document-Listen */
export type AdminDocumentSortInput = {
  field?: AdminDocumentSortField;
  order?: AdminSortOrder;
};

/** Individual documents within an update draft */
export type AdminDraftDocument = {
  __typename?: 'AdminDraftDocument';
  actionType: DraftDocumentAction;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentType: OfficialDocumentType;
  id: Scalars['String']['output'];
  ingestionConfig?: Maybe<Scalars['JSON']['output']>;
  itemData?: Maybe<Scalars['JSON']['output']>;
  jurisdiction: OfficialDocumentJurisdictions;
  name: Scalars['String']['output'];
  parentDocument?: Maybe<Document>;
  parentDocumentId?: Maybe<Scalars['String']['output']>;
  processingStatus: ProcessingStatus;
  reference: Scalars['String']['output'];
  relationshipType: DocumentRelationshipType;
  replacesDocument?: Maybe<Document>;
  replacesDocumentId?: Maybe<Scalars['String']['output']>;
  updateDraft?: Maybe<AdminUpdateDraft>;
  updateDraftId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vaultPath?: Maybe<Scalars['String']['output']>;
};

/** Statistics about an update draft */
export type AdminDraftStatistics = {
  __typename?: 'AdminDraftStatistics';
  documentItems: Scalars['Int']['output'];
  newDocuments: Scalars['Int']['output'];
  processingComplete: Scalars['Int']['output'];
  readyForPublishing: Scalars['Boolean']['output'];
  replacementDocuments: Scalars['Int']['output'];
  systemItems: Scalars['Int']['output'];
  totalDocuments: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

/** Basis-Filter für Admin-Listen */
export type AdminFilterInput = {
  /** Erstellungsdatum von (inclusive) */
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Erstellungsdatum bis (inclusive) */
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Suchbegriff für IDs, Namen, E-Mails */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Basis-Interface für Admin-Listen-Knoten */
export type AdminNode = {
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
};

/** Paginierungs-Informationen für Admin-Listen */
export type AdminPageInfo = {
  __typename?: 'AdminPageInfo';
  /** Cursor für nächste Seite */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Gibt es weitere Seiten? */
  hasNextPage: Scalars['Boolean']['output'];
  /** Gesamtanzahl verfügbarer Einträge (geschätzt) */
  totalCount: Scalars['Int']['output'];
};

export type AdminRepairActionResult = {
  __typename?: 'AdminRepairActionResult';
  affectedCount: Scalars['Int']['output'];
  data?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Sortierreihenfolge für Admin-Listen */
export enum AdminSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Single system draft containing multiple items for batch publishing */
export type AdminUpdateDraft = {
  __typename?: 'AdminUpdateDraft';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentCount?: Maybe<Scalars['Int']['output']>;
  draftDocuments: Array<AdminDraftDocument>;
  id: Scalars['String']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  managedBy?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  scheduledPublishAt?: Maybe<Scalars['DateTime']['output']>;
  status: UpdateStatus;
  title: Scalars['String']['output'];
  updateItems: Array<UpdateItem>;
  updatedAt: Scalars['DateTime']['output'];
};

/** User-Daten für Admin-Interface */
export type AdminUser = AdminNode & {
  __typename?: 'AdminUser';
  /** Firma des Nutzers */
  company?: Maybe<AdminUserCompany>;
  createdAt: Scalars['DateTime']['output'];
  /** E-Mail-Adresse des Nutzers */
  email?: Maybe<Scalars['String']['output']>;
  /** Ist die E-Mail-Adresse verifiziert? */
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Zeitpunkt der letzten Anmeldung */
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  /** Vollständiger Name des Nutzers */
  name?: Maybe<Scalars['String']['output']>;
  /** Aktuelle Seitenkontingent */
  pageQuota: Scalars['Int']['output'];
  /** Nutzerrolle (ADMIN/EDITOR) */
  role: UserRole;
  /** Sitzplatzgröße (S/M/L) */
  size: UserSize;
  /** Verbrauchte Seiten */
  usedPages: Scalars['Int']['output'];
};

/** Company-Informationen im User-Context */
export type AdminUserCompany = {
  __typename?: 'AdminUserCompany';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Paginierte Liste von AdminUser für Admin */
export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  /** Liste der Knoten mit Cursors */
  edges: Array<AdminUserEdge>;
  /** Paginierungs-Informationen */
  pageInfo: AdminPageInfo;
};

/** Edge für AdminUser in Admin-Listen */
export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** Cursor für diese Position */
  cursor: Scalars['String']['output'];
  node: AdminUser;
};

/** Filter für User-Listen im Admin */
export type AdminUserFilterInput = {
  /** Filter nach Company-ID */
  companyId?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter nach E-Mail-Verifizierung */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hat sich in den letzten 30 Tagen angemeldet */
  hasRecentLogin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter nach Nutzerrolle */
  role?: InputMaybe<UserRole>;
  /** Suche in E-Mail, Name oder User-ID */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter nach Sitzplatzgröße */
  size?: InputMaybe<UserSize>;
};

/** Sortierfelder für User-Listen */
export enum AdminUserSortField {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  LastLoginAt = 'LAST_LOGIN_AT',
  Name = 'NAME',
  UsedPages = 'USED_PAGES'
}

/** Sortierung für User-Listen */
export type AdminUserSortInput = {
  field?: AdminUserSortField;
  order?: AdminSortOrder;
};

/** Antwort bei erfolgreicher Authentifizierung. */
export type AuthPayload = {
  __typename?: 'AuthPayload';
  /** Token des User zum Authentifizieren von Anfragen. */
  authToken: Scalars['String']['output'];
  /** Email des Users. */
  email: Scalars['String']['output'];
  /** UUID des Users */
  id: Scalars['ID']['output'];
};

/** Version bump type for document changes */
export enum BumpType {
  Hotfix = 'HOTFIX',
  Major = 'MAJOR',
  Minor = 'MINOR',
  Patch = 'PATCH'
}

/** Chat Basisobjekt */
export type Chat = {
  __typename?: 'Chat';
  /** Aktiver Kontext des Chats */
  activeContext: Context;
  /** Unternehmenskontext Einstellung des Chats */
  companyContextEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Erstellungsdatum des Chats */
  createdAt: Scalars['String']['output'];
  /** ID des Besitzers des Chats */
  creatorId: Scalars['ID']['output'];
  /** Name des Besitzers des Chats */
  creatorName: Scalars['String']['output'];
  /** Zeitpunkt der Löschung (wenn soft-deleted) */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** Automatisch generierte Zusammenfassung des Chats */
  generatedSummary?: Maybe<Scalars['String']['output']>;
  /** GPT-only Einstellung des Chats */
  gptOnlyEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Graph Einstellung des Chats */
  graphEnabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Gibt an, ob der Chat für den aktuellen Benutzer als Favorit markiert ist */
  isFavorite: Scalars['Boolean']['output'];
  /** Gibt an, ob im Chat gerade generiert wird */
  isGenerating: Scalars['Boolean']['output'];
  /** Gibt an, ob der Chat privat ist */
  isPrivate: Scalars['Boolean']['output'];
  /** Nachrichten in diesem Chat */
  messages: Array<Message>;
  /** Name des Chats */
  name: Scalars['String']['output'];
  /** Einstellungen des Chats, als JSON */
  settings?: Maybe<Scalars['JSON']['output']>;
  /** Anzahl der Nachrichten im Chat */
  sizeInMessages: Scalars['Int']['output'];
  /** Anzahl der Seiten im Chat */
  sizeInPages: Scalars['Int']['output'];
  /** Anzahl der Tokens im Chat */
  sizeInTokens: Scalars['Int']['output'];
  /** Anzahl der insgesamt ausgegebenen Seiten im Chat */
  totalPagesSpent: Scalars['Int']['output'];
  /** Anzahl der insgesamt ausgegebenen Tokens im Chat */
  totalTokensSpent: Scalars['Int']['output'];
  /** Letztes Änderungsdatum des Chats */
  updatedAt: Scalars['String']['output'];
};

/** Unternehmensobjekt (Firma) */
export type Company = {
  __typename?: 'Company';
  /** Erstellungsdatum der Firma */
  createdAt: Scalars['String']['output'];
  /** Zusätzliche Informationen zur Firma */
  details?: Maybe<CompanyDetails>;
  /** Ausgewählte Dokumente für dieses Unternehmen */
  documentSelections: Array<CompanyDocumentSelection>;
  /** Freie Seitenanzahl */
  freePageQuota: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Offene und genutzte Einladungscodes dieser Firma */
  inviteLinks: Array<InviteLink>;
  /** Name der Firma */
  name: Scalars['String']['output'];
  /** Firmenbesitzer */
  owner?: Maybe<User>;
  /** ID des Firmenbesitzers */
  ownerId: Scalars['String']['output'];
  /** Aktuelles Abonnement der Firma */
  subscription?: Maybe<Subscription>;
  /** Letztes Änderungsdatum der Firma */
  updatedAt: Scalars['String']['output'];
  /** Liste der Mitglieder der Firma */
  users: Array<User>;
};

/** Details einer Firma */
export type CompanyDetails = {
  __typename?: 'CompanyDetails';
  companyId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employeeCount?: Maybe<Scalars['String']['output']>;
  generatedProfile?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if profile generation is currently in progress */
  isGeneratingProfile: Scalars['Boolean']['output'];
  metadata: Scalars['JSON']['output'];
};

export type CompanyDocumentSelection = {
  __typename?: 'CompanyDocumentSelection';
  /** Das Unternehmen, das dieses Dokument ausgewählt hat */
  company?: Maybe<Company>;
  /** ID des Unternehmens */
  companyId: Scalars['ID']['output'];
  /** Erstellungszeitpunkt */
  createdAt: Scalars['String']['output'];
  /** Das ausgewählte Dokument */
  document?: Maybe<Document>;
  /** ID des ausgewählten Dokuments */
  documentId: Scalars['ID']['output'];
  /** Eindeutige ID der Dokumentenauswahl */
  id: Scalars['ID']['output'];
  /** Ob das Dokument für das Unternehmen aktiv ist */
  isActive: Scalars['Boolean']['output'];
  /** Zeitpunkt der letzten Aktualisierung */
  updatedAt: Scalars['String']['output'];
};

export type CompanyUpload = {
  __typename?: 'CompanyUpload';
  /** Timestamp when the file was soft-deleted */
  deletedAt?: Maybe<Scalars['String']['output']>;
  /** User-friendly display name for the file */
  displayName: Scalars['String']['output'];
  /** Name of the uploaded file */
  filename: Scalars['String']['output'];
  /** Relative path to access the uploaded file */
  path: Scalars['String']['output'];
  /** Path to access the extracted text file */
  textPath?: Maybe<Scalars['String']['output']>;
  /** Number of tokens in the document text */
  tokenCount?: Maybe<Scalars['Int']['output']>;
  /** When the document was uploaded */
  uploadedAt: Scalars['String']['output'];
};

export type ConsentInput = {
  /** Type of consent (AGB, DATENSCHUTZ) */
  type: Scalars['String']['input'];
};

/** Ein Knoten, der einen Inhalt repräsentiert */
export type ContentNode = {
  __typename?: 'ContentNode';
  /** Das offizielle Dokument, dem dieser Inhalt zugeordnet ist */
  associatedOfficialDocument?: Maybe<Document>;
  /** Liste der untergeordneten Inhalte */
  childNodes: Array<ContentNode>;
  /** Verbundene Kontexte */
  contexts: Array<Context>;
  /** Erstellungsdatum des Inhalts */
  createdAt: Scalars['String']['output'];
  /** Hover-Titel des Inhalts */
  hoverTitle?: Maybe<Scalars['String']['output']>;
  /** Eindeutige Kennung des Inhalts */
  id: Scalars['ID']['output'];
  /** Gibt an, ob der Inhalt als Prompt abgefragt werden kann */
  isPromptable?: Maybe<Scalars['Boolean']['output']>;
  /** Gibt an, ob der Inhalt direkt einsehbar ist */
  isViewable?: Maybe<Scalars['Boolean']['output']>;
  /** Zusätzliche Metadaten des Inhalts */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Name des Inhalts */
  name?: Maybe<Scalars['String']['output']>;
  /** Der übergeordnete Inhalt */
  parentNode?: Maybe<ContentNode>;
  /** ID des übergeordneten Inhalts (falls vorhanden) */
  parentNodeId?: Maybe<Scalars['String']['output']>;
  /** Die Anzahl der Seiten im Inhalt */
  sizeInPages: Scalars['Int']['output'];
  /** Die Größe des Inhalts in Tokens */
  sizeInTokens: Scalars['Int']['output'];
  /** Der Text des Inhalts */
  text: Scalars['String']['output'];
  /** Der Typ des Inhalts */
  type: ContentNodeType;
  /** Letztes Aktualisierungsdatum des Inhalts */
  updatedAt: Scalars['String']['output'];
};

/** Typ einer ContentNode */
export enum ContentNodeType {
  DetailedSummary = 'DETAILED_SUMMARY',
  FullSummary = 'FULL_SUMMARY',
  GraphSummary = 'GRAPH_SUMMARY',
  Header = 'HEADER',
  MainContent = 'MAIN_CONTENT',
  References = 'REFERENCES',
  RequirementsSummary = 'REQUIREMENTS_SUMMARY',
  SubSection = 'SUB_SECTION',
  Summary = 'SUMMARY',
  Toc = 'TOC'
}

export type Context = {
  __typename?: 'Context';
  /** Chat, in dem der Kontext aktiv ist */
  activeInChat?: Maybe<Chat>;
  /** Angehängte Dateien im Chat (nur für aktiven Kontext) */
  attachments: Array<Maybe<MessageAttachment>>;
  /** Gibt an, ob der Unternehmenskontext aktiviert ist */
  companyContextEnabled: Scalars['Boolean']['output'];
  /** Inhalte des Kontexts */
  contentNodes: Array<Maybe<ContentNode>>;
  /** Prozentuale Auslastung des Kontexts */
  contextUsagePercentage?: Maybe<Scalars['Float']['output']>;
  /** Erstellungszeitpunkt des Kontexts */
  createdAt: Scalars['String']['output'];
  /** Dokumente des Kontexts */
  documents: Array<Maybe<Document>>;
  /** Gibt an, ob der GPT-only Modus aktiviert ist */
  gptOnlyEnabled: Scalars['Boolean']['output'];
  /** Gibt an, ob der Graph-Modus aktiviert ist */
  graphEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Gibt an, ob der Kontext gesperrt ist */
  isLocked: Scalars['Boolean']['output'];
  /** Maximale Anzahl an Tokens für den Kontext */
  maxContextTokens?: Maybe<Scalars['Int']['output']>;
  /** Nachrichten des Kontexts */
  messages: Array<Maybe<Message>>;
  /** Größe des Kontexts in Seiten */
  sizeInPages?: Maybe<Scalars['Int']['output']>;
  /** Größe des Kontexts in Tokens (nur Dokumente) */
  sizeInTokens?: Maybe<Scalars['Int']['output']>;
  /** Füllungsanteil des Kontexts in Prozent */
  totalAllowedPages?: Maybe<Scalars['Int']['output']>;
  /** Gesamtgröße des Kontexts in Tokens (Dokumente + angehängte Dateien + Nachrichten) */
  totalContextTokens?: Maybe<Scalars['Int']['output']>;
  /** Letzter Änderungszeitpunkt des Kontexts */
  updatedAt: Scalars['String']['output'];
  /** Verwendete Inhalte im Chat */
  usedContentNodes: Array<Maybe<ContentNode>>;
};

export type CostBreakdown = {
  __typename?: 'CostBreakdown';
  cost: Scalars['Float']['output'];
  stage: Scalars['String']['output'];
  tokens: Scalars['Int']['output'];
};

export type CostEstimate = {
  __typename?: 'CostEstimate';
  breakdown: Array<CostBreakdown>;
  confidence: Scalars['String']['output'];
  estimatedCost: Scalars['Float']['output'];
  estimatedTokens: Scalars['Int']['output'];
  factors: CostFactors;
};

export type CostFactors = {
  __typename?: 'CostFactors';
  complexity: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  selectedStages: Array<Scalars['String']['output']>;
};

/** Input for creating system-wide notifications (admin only) */
export type CreateSystemNotificationInput = {
  /** Optional JSON object with detailed changes */
  changesSummary?: InputMaybe<Scalars['JSON']['input']>;
  /** Notification description/content */
  description: Scalars['String']['input'];
  /** Notification title */
  title: Scalars['String']['input'];
  /** Type of update (defaults to MINOR) */
  updateType?: InputMaybe<BumpType>;
};

/** Input for creating a new update draft */
export type CreateUpdateDraftInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Input for creating a new update */
export type CreateUpdateInput = {
  category: UpdateCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<UpdateSource>;
  title: Scalars['String']['input'];
  triggerType?: InputMaybe<Scalars['String']['input']>;
};

/** Input for dismissing a notification */
export type DismissNotificationInput = {
  notificationId: Scalars['String']['input'];
};

export type Document = {
  __typename?: 'Document';
  /** ID des Dokuments, das von diesem Dokument geändert wird */
  amendsDocumentId?: Maybe<Scalars['String']['output']>;
  /** Referenz des Dokuments, das von diesem Dokument geändert wird */
  amendsDocumentReference?: Maybe<Scalars['String']['output']>;
  /** Kategorie des Dokuments */
  category?: Maybe<Scalars['String']['output']>;
  /** Der bereinigte Inhalt des Dokuments */
  cleanContent: Scalars['String']['output'];
  /** Datum und Uhrzeit der Erstellung */
  createdAt: Scalars['String']['output'];
  /** Eine kurze Beschreibung des Dokuments */
  description?: Maybe<Scalars['String']['output']>;
  /** Externer Link, der mit dem Dokument verknüpft ist */
  externalLink?: Maybe<Scalars['String']['output']>;
  /** Name of the document group (if any) */
  groupName?: Maybe<Scalars['String']['output']>;
  /** Hover-Titel des Dokuments */
  hoverTitle?: Maybe<Scalars['String']['output']>;
  /** Die eindeutige Kennung des Dokuments */
  id: Scalars['ID']['output'];
  /** Indicates if this document is active for the current company */
  isActiveForCompany?: Maybe<Scalars['Boolean']['output']>;
  /** True wenn diese Version die aktuellste für ihre Referenz ist. */
  isLatest: Scalars['Boolean']['output'];
  /** Jurisdiktion des Dokuments (EU, DE, OTHER) */
  jurisdiction?: Maybe<Scalars['String']['output']>;
  /** Metadaten der spezifischen GraphQL-Schicht */
  layerMetadata: Scalars['JSON']['output'];
  /** Zusätzliche Metadaten des Dokuments */
  metadata: Scalars['JSON']['output'];
  /** Der Name des Dokuments */
  name: Scalars['String']['output'];
  /** Offizielle Versionsbezeichnung des Dokuments */
  officialVersion?: Maybe<Scalars['String']['output']>;
  /** Direct URL to download the PDF file */
  pdfFileUrl: Scalars['String']['output'];
  /** URL zur PDF-Version des Dokuments */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** Dateireferenz des Dokuments */
  reference: Scalars['String']['output'];
  /** Die vom Client angeforderte Dokument-ID (für Banner-Anzeige). */
  requestedId?: Maybe<Scalars['ID']['output']>;
  /** The root content node of the document */
  rootContentNode?: Maybe<ContentNode>;
  /** Anzahl der Seiten im Dokument */
  sizeInPages: Scalars['Int']['output'];
  /** Größe des Dokuments in Tokens */
  sizeInTokens: Scalars['Int']['output'];
  /** Datum und Uhrzeit der letzten Aktualisierung */
  updatedAt: Scalars['String']['output'];
  /** Hauptversionsnummer des Dokuments */
  version_major: Scalars['Int']['output'];
  /** Nebenversionsnummer des Dokuments */
  version_minor: Scalars['Int']['output'];
};

/** Filter options for querying official documents */
export type DocumentFilterInput = {
  /** The term to search in document names and descriptions */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Document type */
  type?: InputMaybe<DocumentFilterTypeEnum>;
};

/** Document type (e.g. "all", "system", "company") */
export enum DocumentFilterTypeEnum {
  All = 'all',
  System = 'system'
}

export type DocumentMetadataInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  complexity?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentType: OfficialDocumentType;
  estimatedPageCount?: InputMaybe<Scalars['Int']['input']>;
  fileSize: Scalars['Int']['input'];
  hasComplexLayout?: InputMaybe<Scalars['Boolean']['input']>;
  hasImages?: InputMaybe<Scalars['Boolean']['input']>;
  jurisdiction: OfficialDocumentJurisdictions;
  name: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

/** Relationship type for document hierarchy */
export enum DocumentRelationshipType {
  Amendment = 'AMENDMENT',
  Original = 'ORIGINAL',
  SoftLaw = 'SOFT_LAW',
  Subdocument = 'SUBDOCUMENT'
}

/** Sort field (e.g. "title", "date", "size") */
export enum DocumentSortFieldEnum {
  Date = 'date',
  Size = 'size',
  Title = 'title'
}

/** Sort options for querying official documents */
export type DocumentSortInput = {
  /** Sort field */
  field?: InputMaybe<DocumentSortFieldEnum>;
  /** Sort order */
  order?: InputMaybe<DocumentSortOrderEnum>;
};

/** Sort order (e.g. "asc", "desc") */
export enum DocumentSortOrderEnum {
  Asc = 'asc',
  Desc = 'desc'
}

/** Source type for documents (local upload or online source) */
export enum DocumentSourceType {
  DeOnline = 'DE_ONLINE',
  EuOnline = 'EU_ONLINE',
  External = 'EXTERNAL',
  Local = 'LOCAL'
}

/** Sync result for individual document */
export type DocumentSyncItem = {
  __typename?: 'DocumentSyncItem';
  /** Error message if sync failed for this document */
  error?: Maybe<Scalars['String']['output']>;
  /** ISO timestamp when document was last checked */
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  /** Document name */
  name?: Maybe<Scalars['String']['output']>;
  /** Document reference identifier */
  reference?: Maybe<Scalars['String']['output']>;
  /** Source type (e.g., DE_ONLINE, EU_ONLINE) */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** Sync status (e.g., Up to date, Update available, Download failed) */
  status: Scalars['String']['output'];
};

/** Result of document synchronization operation */
export type DocumentSyncResult = {
  __typename?: 'DocumentSyncResult';
  /** Error message if sync failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Individual document sync results */
  results: Array<Maybe<DocumentSyncItem>>;
  /** Whether the sync operation was successful */
  success: Scalars['Boolean']['output'];
  /** ISO timestamp when sync completed */
  timestamp: Scalars['String']['output'];
};

/** Legacy notification structure for frontend compatibility */
export type DocumentUpdateNotification = {
  __typename?: 'DocumentUpdateNotification';
  changesSummary?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<LegacyDocument>;
  documentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isRead: Scalars['Boolean']['output'];
  /** List of all items included in this update notification */
  items?: Maybe<Array<Maybe<LegacyDocumentUpdateItem>>>;
  newVersion: Scalars['String']['output'];
  previousVersion: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  updateType: BumpType;
  userId: Scalars['String']['output'];
};

/** Action type for documents within a draft */
export enum DraftDocumentAction {
  Delete = 'DELETE',
  New = 'NEW',
  Replacement = 'REPLACEMENT'
}

export type DraftState = {
  __typename?: 'DraftState';
  category: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Invite Link in eine Company */
export type InviteLink = {
  __typename?: 'InviteLink';
  code: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  role: UserRole;
  size: UserSize;
  updatedAt: Scalars['String']['output'];
  usedBy?: Maybe<User>;
  usedById?: Maybe<Scalars['String']['output']>;
};

/** Legacy document structure for notification compatibility */
export type LegacyDocument = {
  __typename?: 'LegacyDocument';
  id: Scalars['String']['output'];
  jurisdiction: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version_major: Scalars['Int']['output'];
  version_minor: Scalars['Int']['output'];
};

/** Individual item details for document update notifications */
export type LegacyDocumentUpdateItem = {
  __typename?: 'LegacyDocumentUpdateItem';
  changeSummary?: Maybe<Scalars['String']['output']>;
  document?: Maybe<LegacyDocument>;
  documentId: Scalars['String']['output'];
  itemType?: Maybe<UpdateItemType>;
  updateType?: Maybe<BumpType>;
};

/** Legacy input for marking all notifications as read */
export type LegacyMarkAllNotificationsReadInput = {
  /** Mark all notifications before this date as read (optional) */
  beforeDate?: InputMaybe<Scalars['String']['input']>;
};

/** Legacy input for marking a notification as read */
export type LegacyMarkNotificationReadInput = {
  notificationId: Scalars['String']['input'];
};

/** Legacy notification connection for frontend compatibility */
export type LegacyNotificationConnection = {
  __typename?: 'LegacyNotificationConnection';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<DocumentUpdateNotification>;
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** Details für manuell gewährte Abonnements */
export type ManualSubscriptionInfo = {
  __typename?: 'ManualSubscriptionInfo';
  /** Grund für die manuelle Gewährung */
  grantReason?: Maybe<Scalars['String']['output']>;
  /** Wann das Abonnement gewährt wurde */
  grantedAt?: Maybe<Scalars['String']['output']>;
  /** Von wem das Abonnement gewährt wurde */
  grantedBy?: Maybe<Scalars['String']['output']>;
};

/** Input for marking all notifications as read */
export type MarkAllNotificationsReadInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<NotificationPriority>;
};

/** Input for marking notification as read */
export type MarkNotificationReadInput = {
  notificationId: Scalars['String']['input'];
};

/** Nachricht in einem Chat */
export type Message = {
  __typename?: 'Message';
  /** Angehängte Dateien */
  attachments?: Maybe<Array<Maybe<MessageAttachment>>>;
  /** Zugehöriger Chat */
  chat: Chat;
  /** ID des zugehörigen Chats */
  chatId: Scalars['String']['output'];
  /** Inhalt der Nachricht */
  content: Scalars['String']['output'];
  /** Zugehöriger Kontext */
  context?: Maybe<Context>;
  /** Erstellungszeitpunkt der Nachricht */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Absender der Nachricht (null bei Bot-Nachrichten) */
  sender?: Maybe<User>;
  /** ID des Absenders (null bei Bot-Nachrichten) */
  senderId?: Maybe<Scalars['String']['output']>;
  /** Zugehöriger TaskRecord (nur für Bot-Nachrichten) */
  taskRecord?: Maybe<TaskRecord>;
  /** Typ der Nachricht (USER oder BOT) */
  type: MessageType;
  /** Letzter Änderungszeitpunkt der Nachricht */
  updatedAt: Scalars['String']['output'];
};

/** Anhang einer Nachricht */
export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  /** Extrahierter Textinhalt der angehängten Datei */
  content: Scalars['String']['output'];
  /** Erstellungszeitpunkt des Anhangs */
  createdAt: Scalars['String']['output'];
  /** Name der angehängten Datei */
  fileName: Scalars['String']['output'];
  /** Größe der angehängten Datei in Bytes */
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** ID der zugehörigen Nachricht */
  messageId: Scalars['String']['output'];
  /** Anzahl der Seiten (berechnet aus Tokens) */
  pages?: Maybe<Scalars['Int']['output']>;
  /** Token-Anzahl der angehängten Datei */
  tokens: Scalars['Int']['output'];
};

export type MessageAttachmentInput = {
  content: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  tokens: Scalars['Int']['input'];
};

/** Typ einer Nachricht */
export enum MessageType {
  Bot = 'BOT',
  User = 'USER'
}

export type MoveUserToSeatPayload = {
  __typename?: 'MoveUserToSeatPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Mark a notification as acknowledged */
  acknowledgeNotification?: Maybe<UserNotification>;
  /** Add a document to the current update draft */
  adminAddDocumentToDraft?: Maybe<AdminDraftDocument>;
  /** Cancel the current active draft */
  adminCancelCurrentDraft: Scalars['Boolean']['output'];
  /** Check the health status of document links */
  adminCheckLinkHealth?: Maybe<Scalars['JSON']['output']>;
  /** Create a new update draft (cancels any existing active draft) */
  adminCreateUpdateDraft?: Maybe<AdminUpdateDraft>;
  /** Generate all possible document links from a source URL */
  adminGenerateLinksFromUrl?: Maybe<Scalars['JSON']['output']>;
  /** Get statistics about link health across all documents */
  adminGetLinkHealthStats?: Maybe<Scalars['JSON']['output']>;
  /** Get list of documents with broken or missing links */
  adminGetUnhealthyDocuments?: Maybe<Scalars['JSON']['output']>;
  /** Auto-heal all documents with missing link fields */
  adminHealAllDocuments?: Maybe<Scalars['JSON']['output']>;
  /** Manually heal missing link fields for a document */
  adminHealDocumentLinks?: Maybe<Scalars['JSON']['output']>;
  /** Permanently delete a document and all its content nodes (bypasses soft deletion) */
  adminPermanentlyDeleteDocument: Scalars['Boolean']['output'];
  /** Publish an update draft and send notifications to users */
  adminPublishUpdateDraft?: Maybe<PublishDraftResult>;
  /** Remove a document from the draft */
  adminRemoveDraftDocument: Scalars['Boolean']['output'];
  /** Restore a soft-deleted document and its content nodes */
  adminRestoreDocument: Scalars['Boolean']['output'];
  /** Manually trigger the enhanced document synchronization job */
  adminRunDocumentSync?: Maybe<Scalars['JSON']['output']>;
  /** Manually trigger the link health check and healing job */
  adminRunLinkHealthJob?: Maybe<Scalars['JSON']['output']>;
  adminRunRepairAction: AdminRepairActionResult;
  /** Manually trigger synchronization of online documents */
  adminSyncDocuments?: Maybe<DocumentSyncResult>;
  /** Update the processing status of a draft document */
  adminUpdateDocumentProcessingStatus?: Maybe<AdminDraftDocument>;
  /** Update draft title and description */
  adminUpdateDraftDetails?: Maybe<AdminUpdateDraft>;
  /** Update the status of an update draft */
  adminUpdateDraftStatus?: Maybe<AdminUpdateDraft>;
  /** Validate that a PDF URL is accessible and downloadable with valid PDF content */
  adminValidatePdfUrl?: Maybe<Scalars['JSON']['output']>;
  /** DEPRECATED: Diese Funktion wird nicht mehr verwendet, da wir generatedProfile und description getrennt halten wollen. */
  applyGeneratedProfile: CompanyDetails;
  /** Erzeugt eine URL für das Stripe-Kundenportal */
  billingPortalUrl?: Maybe<Scalars['String']['output']>;
  /** Aktiviert oder deaktiviert mehrere Dokumente gleichzeitig */
  bulkToggleDocumentSelections: Array<CompanyDocumentSelection>;
  changeEmail?: Maybe<User>;
  changePassword?: Maybe<User>;
  clearCheckoutState?: Maybe<Scalars['Boolean']['output']>;
  /** Entfernt alle Content Nodes aus dem aktiven Chat-Kontext */
  clearContextSelection: Context;
  clearDraftState?: Maybe<Scalars['Boolean']['output']>;
  /** Consume one service credit of the specified type */
  consumeServiceCredit: Scalars['Boolean']['output'];
  createChat: Chat;
  /** Erstellt eine neue Firma */
  createCompany: Company;
  /** Submit a contact request to the ESGbot support team. */
  createContactMessage: Scalars['Boolean']['output'];
  createInviteLink?: Maybe<InviteLink>;
  /** Erstellt einen neuen Nutzer in der Firma */
  createUserInCompany: User;
  /** Flexible Debugging */
  debug: User;
  /** Development-only: Grant a service credit for testing */
  debugGrantServiceCredit: Scalars['Boolean']['output'];
  /** Löscht einen Chat */
  deleteChat: Chat;
  /** Delete an uploaded document for a company */
  deleteCompanyUpload: Scalars['Boolean']['output'];
  deleteInviteLink?: Maybe<InviteLink>;
  /** Löscht eine Nachricht aus einem Chat */
  deleteMessage: Message;
  deleteUser?: Maybe<User>;
  /** Diagnoses seat assignment logic for a company */
  diagnoseSeatAssignment?: Maybe<Scalars['JSON']['output']>;
  /** Mark a notification as dismissed */
  dismissNotification?: Maybe<UserNotification>;
  /** Updates specific chat settings like graph mode */
  editChatSettings: Chat;
  /** Generates a new AVV (Auftragsverarbeitungsvertrag) document for the company */
  generateAVV: AvvResponse;
  /** Generiert ein neues Firmen-Profil */
  generateCompanyProfile: CompanyDetails;
  /** Generate a company profile from uploaded documents */
  generateCompanyProfileFromUploads?: Maybe<Scalars['String']['output']>;
  /** Authentifiziert einen User. */
  login: AuthPayload;
  /** Manually triggers seat assignment for testing */
  manualSeatAssignment?: Maybe<Scalars['JSON']['output']>;
  /** Mark all notifications as read for current user, returns count of updated notifications */
  markAllNotificationsRead?: Maybe<Scalars['Int']['output']>;
  /** Mark a notification as read and return the updated notification */
  markNotificationRead?: Maybe<UserNotification>;
  moveUserToSeat?: Maybe<MoveUserToSeatPayload>;
  /** Records user consent for AGB and Datenschutzerklärung */
  recordConsent: Scalars['Boolean']['output'];
  /** Entfernt einen spezifischen Anhang anhand seiner ID */
  removeAttachment?: Maybe<MessageAttachment>;
  /** Benennt einen Chat um */
  renameChat: Chat;
  /** Request a password reset email for the given email address */
  requestPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Reset password using a valid reset token */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  /** Speichert den aktuellen Checkout-Zustand des Benutzers für spätere Wiederherstellung */
  saveCheckoutState?: Maybe<Scalars['Boolean']['output']>;
  saveDraftState?: Maybe<DraftState>;
  /** Fügt einen Content Node zum Chat-Kontext hinzu oder entfernt ihn */
  selectContentNode: ContentNode;
  /** Allows the company owner to select their seat type from available options */
  selectOwnerSeat?: Maybe<Scalars['JSON']['output']>;
  /** Sends an email verification link to the user. */
  sendEmailVerification: Scalars['String']['output'];
  /** Sendet eine neue Nachricht in einem Chat */
  sendMessage: Message;
  /** Registriert einen neuen User und gibt ein Auth-Token zurück. */
  signup: AuthPayload;
  swapUserSeats?: Maybe<SwapUserSeatsPayload>;
  /** Markiert einen Chat als Favorit oder entfernt ihn aus den Favoriten */
  toggleChatFavorite: Chat;
  /** Ändert den Privat-Status eines Chats */
  toggleChatPrivacy: Chat;
  /** Aktiviert oder deaktiviert ein Dokument für das aktuelle Unternehmen */
  toggleDocumentSelection: CompanyDocumentSelection;
  /** Einheitlicher Checkout der intelligent neue Abonnements oder Sitz-Updates verwaltet */
  unifiedCheckout: Scalars['String']['output'];
  /** Meldet den Benutzer von allen Newsletter-Listen ab */
  unsubscribeFromAllLists?: Maybe<NewsletterSettings>;
  /** Aktualisiert die Firmendaten */
  updateCompany: Company;
  /** Aktualisiert nur das generierte Firmenprofil, separat von der Beschreibung */
  updateCompanyProfile: CompanyDetails;
  updateInviteLinkSize?: Maybe<InviteLink>;
  /** Aktualisiert die Newsletter-Einstellungen für den aktuellen Benutzer */
  updateNewsletterSettings?: Maybe<NewsletterSettings>;
  updateQuotaDistribution?: Maybe<Company>;
  updateUser?: Maybe<User>;
  /** Use an invite link to create a new user and join a company */
  useInviteLink: AuthPayload;
  /** Verbraucht einen QUICK_WESENTLICHKEIT Credit und erstellt einen ServiceJob */
  useQuickWesentlichkeit: ServiceJob;
  /** Verbraucht einen VSME_REPORT Credit und erstellt einen ServiceJob */
  useVsmeReport: ServiceJob;
  /** Verifies an email address using the verification token. */
  verifyEmail: Scalars['String']['output'];
  /** Überprüft eine Stripe-Session und gibt Details zurück */
  verifySession: Scalars['JSON']['output'];
};


export type MutationAcknowledgeNotificationArgs = {
  input: AcknowledgeNotificationInput;
};


export type MutationAdminAddDocumentToDraftArgs = {
  draftId: Scalars['String']['input'];
  input: AddDraftDocumentInput;
};


export type MutationAdminCheckLinkHealthArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationAdminCreateUpdateDraftArgs = {
  input: CreateUpdateDraftInput;
};


export type MutationAdminGenerateLinksFromUrlArgs = {
  sourceType?: InputMaybe<DocumentSourceType>;
  url: Scalars['String']['input'];
};


export type MutationAdminGetUnhealthyDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<DocumentSourceType>;
};


export type MutationAdminHealAllDocumentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<DocumentSourceType>;
};


export type MutationAdminHealDocumentLinksArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationAdminPermanentlyDeleteDocumentArgs = {
  documentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminPublishUpdateDraftArgs = {
  draftId: Scalars['String']['input'];
};


export type MutationAdminRemoveDraftDocumentArgs = {
  documentId: Scalars['String']['input'];
};


export type MutationAdminRestoreDocumentArgs = {
  documentId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminRunDocumentSyncArgs = {
  autoHeal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<DocumentSourceType>;
};


export type MutationAdminRunLinkHealthJobArgs = {
  autoHeal?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceType?: InputMaybe<DocumentSourceType>;
};


export type MutationAdminRunRepairActionArgs = {
  action: Scalars['String']['input'];
};


export type MutationAdminSyncDocumentsArgs = {
  triggerSource?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminUpdateDocumentProcessingStatusArgs = {
  documentId: Scalars['String']['input'];
  status: ProcessingStatus;
};


export type MutationAdminUpdateDraftDetailsArgs = {
  draftId: Scalars['String']['input'];
  input: UpdateDraftDetailsInput;
};


export type MutationAdminUpdateDraftStatusArgs = {
  draftId: Scalars['String']['input'];
  status: UpdateDraftStatus;
};


export type MutationAdminValidatePdfUrlArgs = {
  url: Scalars['String']['input'];
};


export type MutationBulkToggleDocumentSelectionsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  isActive: Scalars['Boolean']['input'];
};


export type MutationChangeEmailArgs = {
  newEmail: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationClearContextSelectionArgs = {
  chatId: Scalars['ID']['input'];
};


export type MutationClearDraftStateArgs = {
  category: Scalars['String']['input'];
};


export type MutationConsumeServiceCreditArgs = {
  type: ServiceCreditType;
};


export type MutationCreateChatArgs = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateCompanyArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateContactMessageArgs = {
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};


export type MutationCreateInviteLinkArgs = {
  email: Scalars['String']['input'];
  role: UserRole;
  size: UserSize;
};


export type MutationCreateUserInCompanyArgs = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDebugArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationDebugGrantServiceCreditArgs = {
  type: ServiceCreditType;
};


export type MutationDeleteChatArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCompanyUploadArgs = {
  companyId: Scalars['String']['input'];
  filename: Scalars['String']['input'];
};


export type MutationDeleteInviteLinkArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMessageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiagnoseSeatAssignmentArgs = {
  companyId: Scalars['String']['input'];
  mockSeats?: InputMaybe<SeatDistributionInput>;
};


export type MutationDismissNotificationArgs = {
  input: DismissNotificationInput;
};


export type MutationEditChatSettingsArgs = {
  companyContextEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  gptOnlyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  graphEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationGenerateAvvArgs = {
  avvData: AvvDataInput;
};


export type MutationGenerateCompanyProfileFromUploadsArgs = {
  companyId: Scalars['String']['input'];
  useExistingProfile?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationManualSeatAssignmentArgs = {
  companyId: Scalars['String']['input'];
  mockSeats?: InputMaybe<SeatDistributionInput>;
};


export type MutationMarkAllNotificationsReadArgs = {
  input?: InputMaybe<MarkAllNotificationsReadInput>;
};


export type MutationMarkNotificationReadArgs = {
  input: MarkNotificationReadInput;
};


export type MutationMoveUserToSeatArgs = {
  seatType: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRecordConsentArgs = {
  consents: Array<ConsentInput>;
};


export type MutationRemoveAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationRenameChatArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSaveCheckoutStateArgs = {
  selectedProducts: Array<PriceIdWithQuantityInput>;
};


export type MutationSaveDraftStateArgs = {
  input: SaveDraftStateInput;
};


export type MutationSelectContentNodeArgs = {
  chatId: Scalars['ID']['input'];
  contentNodeId: Scalars['ID']['input'];
  select: Scalars['Boolean']['input'];
};


export type MutationSelectOwnerSeatArgs = {
  seatType: Scalars['String']['input'];
};


export type MutationSendEmailVerificationArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  attachments?: InputMaybe<Array<MessageAttachmentInput>>;
  chatId: Scalars['ID']['input'];
  content: Scalars['String']['input'];
};


export type MutationSignupArgs = {
  devOTP?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationSwapUserSeatsArgs = {
  user1Id: Scalars['ID']['input'];
  user2Id: Scalars['ID']['input'];
};


export type MutationToggleChatFavoriteArgs = {
  id: Scalars['ID']['input'];
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationToggleChatPrivacyArgs = {
  id: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationToggleDocumentSelectionArgs = {
  documentId: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};


export type MutationUnifiedCheckoutArgs = {
  attemptId?: InputMaybe<Scalars['String']['input']>;
  products: Array<PriceIdWithQuantityInput>;
};


export type MutationUpdateCompanyArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  employeeCount?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  websites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateCompanyProfileArgs = {
  profile: Scalars['String']['input'];
};


export type MutationUpdateInviteLinkSizeArgs = {
  id: Scalars['String']['input'];
  size: UserSize;
};


export type MutationUpdateNewsletterSettingsArgs = {
  isSubscribedToDirectList: Scalars['Boolean']['input'];
  isSubscribedToMarketingList: Scalars['Boolean']['input'];
  isSubscribedToNewsletterList: Scalars['Boolean']['input'];
};


export type MutationUpdateQuotaDistributionArgs = {
  companyId: Scalars['ID']['input'];
  freePageQuota: Scalars['Int']['input'];
  userQuotas: Array<InputMaybe<UserQuotaInput>>;
};


export type MutationUpdateUserArgs = {
  chatSettings?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUseInviteLinkArgs = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUseQuickWesentlichkeitArgs = {
  documents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUseVsmeReportArgs = {
  documents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


export type MutationVerifySessionArgs = {
  sessionId: Scalars['String']['input'];
};

/** Einstellungen für Newsletter-Anmeldungen */
export type NewsletterSettings = {
  __typename?: 'NewsletterSettings';
  /** E-Mail-Adresse des Benutzers */
  email: Scalars['String']['output'];
  /** Gibt an, ob der Benutzer zu direkten Updates angemeldet ist (Liste 4) */
  isSubscribedToDirectList: Scalars['Boolean']['output'];
  /** Gibt an, ob der Benutzer zum Marketing-Newsletter angemeldet ist (Liste 3) */
  isSubscribedToMarketingList: Scalars['Boolean']['output'];
  /** Gibt an, ob der Benutzer zum Newsletter angemeldet ist (Liste 1) */
  isSubscribedToNewsletterList: Scalars['Boolean']['output'];
  /** ID des Benutzers */
  userId: Scalars['ID']['output'];
};

/** Paginated user notifications - legacy compatibility format */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<DocumentUpdateNotification>;
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** Filters for querying notifications */
export type NotificationFilters = {
  category?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['DateTime']['input']>;
  createdBefore?: InputMaybe<Scalars['DateTime']['input']>;
  priority?: InputMaybe<NotificationPriority>;
  requiresAction?: InputMaybe<Scalars['Boolean']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Metrics about user notifications for an update */
export type NotificationMetrics = {
  __typename?: 'NotificationMetrics';
  readNotifications: Scalars['Int']['output'];
  readPercentage: Scalars['Int']['output'];
  totalNotifications: Scalars['Int']['output'];
};

/** Priority levels for notifications */
export enum NotificationPriority {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

/** User notification statistics */
export type NotificationStats = {
  __typename?: 'NotificationStats';
  actionRequiredCount: Scalars['Int']['output'];
  highPriorityCount: Scalars['Int']['output'];
  lastNotificationDate?: Maybe<Scalars['DateTime']['output']>;
  totalCount: Scalars['Int']['output'];
  unreadCount: Scalars['Int']['output'];
};

/** Legal jurisdictions for official documents */
export enum OfficialDocumentJurisdictions {
  De = 'DE',
  DeLandesrecht = 'DE_LANDESRECHT',
  Eu = 'EU',
  Other = 'OTHER'
}

/** Types of official documents */
export enum OfficialDocumentType {
  Amendment = 'AMENDMENT',
  Directive = 'DIRECTIVE',
  Law = 'LAW',
  Other = 'OTHER',
  Regulation = 'REGULATION',
  SoftLaw = 'SOFT_LAW'
}

export type Price = {
  __typename?: 'Price';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  priceId: Scalars['String']['output'];
  seatType?: Maybe<Scalars['String']['output']>;
};

/** Wird für den Checkout benötigt */
export type PriceIdWithQuantity = {
  __typename?: 'PriceIDWithQuantity';
  priceId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

/** Input type für den Checkout */
export type PriceIdWithQuantityInput = {
  priceId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type ProcessingConfigInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  documentType: OfficialDocumentType;
  extractFullSummary: Scalars['Boolean']['input'];
  extractReferences: Scalars['Boolean']['input'];
  extractRequirements: Scalars['Boolean']['input'];
  extractSummary: Scalars['Boolean']['input'];
  extractTOC: Scalars['Boolean']['input'];
  jurisdiction: OfficialDocumentJurisdictions;
  model: Scalars['String']['input'];
  processingLevel: Scalars['String']['input'];
  temperature: Scalars['Float']['input'];
};

export type ProcessingDocumentInfo = {
  __typename?: 'ProcessingDocumentInfo';
  complexity: Scalars['String']['output'];
  documentType: OfficialDocumentType;
  estimatedPageCount: Scalars['Int']['output'];
  jurisdiction: OfficialDocumentJurisdictions;
};

export type ProcessingJob = {
  __typename?: 'ProcessingJob';
  actualCost?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  currentStage: Scalars['String']['output'];
  estimatedCost: Scalars['Float']['output'];
  estimatedDurationMs: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  maxRetries: Scalars['Int']['output'];
  progress: Scalars['Int']['output'];
  retryCount: Scalars['Int']['output'];
  stagesCompleted: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ProcessingJobStatus;
  tokenCount?: Maybe<Scalars['Int']['output']>;
  totalStages: Scalars['Int']['output'];
  updateItemId: Scalars['String']['output'];
};

export enum ProcessingJobStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Queued = 'QUEUED'
}

export type ProcessingPlan = {
  __typename?: 'ProcessingPlan';
  documentInfo: ProcessingDocumentInfo;
  jobId: Scalars['String']['output'];
  requiredApprovals: Array<Scalars['String']['output']>;
  stages: Array<ProcessingStage>;
  totalEstimatedCost: Scalars['Float']['output'];
  totalEstimatedDuration: Scalars['Int']['output'];
};

/** Real-time processing progress information */
export type ProcessingProgress = {
  __typename?: 'ProcessingProgress';
  currentOperation?: Maybe<Scalars['String']['output']>;
  currentPageIndex?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  estimatedTimeRemaining?: Maybe<Scalars['Int']['output']>;
  progress: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  totalPages?: Maybe<Scalars['Int']['output']>;
  updateItemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for updating processing progress */
export type ProcessingProgressInput = {
  currentOperation?: InputMaybe<Scalars['String']['input']>;
  currentPageIndex?: InputMaybe<Scalars['Int']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  estimatedTimeRemaining?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['String']['input']>;
  totalPages?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessingResultSummary = {
  __typename?: 'ProcessingResultSummary';
  actualCost: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  extractionConfidence: Scalars['Float']['output'];
  extractionMethod: Scalars['String']['output'];
  files?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
  previewText: Scalars['String']['output'];
  processingDurationMs: Scalars['Int']['output'];
  qualityScore: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  tokenCount: Scalars['Int']['output'];
  updateItemId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProcessingStage = {
  __typename?: 'ProcessingStage';
  dependencies: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  estimatedCost: Scalars['Float']['output'];
  estimatedDurationMs: Scalars['Int']['output'];
  estimatedTokens: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
};

/** Processing status for update items */
export enum ProcessingStatus {
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Uploaded = 'UPLOADED'
}

/** Produkt, das ESGbot zum Verkauf stellt */
export type Product = {
  __typename?: 'Product';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Array<Maybe<Price>>;
  productId: Scalars['String']['output'];
};

/** Result of publishing an update draft */
export type PublishDraftResult = {
  __typename?: 'PublishDraftResult';
  notificationCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Result of publishing an update */
export type PublishUpdateResult = {
  __typename?: 'PublishUpdateResult';
  error?: Maybe<Scalars['String']['output']>;
  notificationCount: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** Get notifications that require user action */
  actionRequiredNotifications: Array<UserNotification>;
  /** Check if a new draft can be created (no active draft exists) */
  adminCanCreateNewDraft: Scalars['Boolean']['output'];
  /** Paginierte Liste aller Companies für Admin */
  adminCompanies: AdminCompanyConnection;
  /** Company-Details für Admin */
  adminCompanyById?: Maybe<AdminCompany>;
  /** Lädt einen einzelnen Content Node inkl. vollem Text (Admin only) */
  adminContentNode?: Maybe<AdminContentNode>;
  /** Content Nodes für ein bestimmtes Dokument */
  adminContentNodesForDocument: AdminContentNodeConnection;
  /** Get the current active update draft */
  adminCurrentUpdateDraft?: Maybe<AdminUpdateDraft>;
  /** Get system-wide statistics for admin dashboard */
  adminDashboardStats: AdminDashboardStats;
  /** Document-Details für Admin */
  adminDocumentById?: Maybe<AdminDocument>;
  /** Get list of available document categories */
  adminDocumentCategories: Array<Scalars['String']['output']>;
  /** Aggregated document metrics for admin dashboard */
  adminDocumentMetrics: AdminDocumentMetrics;
  /** Paginierte Liste aller Dokumente für Admin */
  adminDocuments: AdminDocumentConnection;
  /** Get published updates with pagination */
  adminPublishedDrafts?: Maybe<UpdateConnection>;
  /** Get statistics for current update draft */
  adminUpdateDraftStatistics?: Maybe<AdminDraftStatistics>;
  /** User-Details für Admin */
  adminUserById?: Maybe<AdminUser>;
  /** Paginierte Liste aller Users für Admin */
  adminUsers: AdminUserConnection;
  /** Ausgewählter Chat mit allen Informationen */
  chat: Chat;
  /** Chat Liste mit grundlegenden Informationen */
  chats: Array<Chat>;
  /** Details der aktuellen Firma */
  company: Company;
  /** Alle Invite Links für die eigene Company abrufen */
  companyInviteLinks: Array<InviteLink>;
  /** Get all uploaded documents for a company */
  companyUploads: Array<CompanyUpload>;
  /** Holt den aktiven Kontext für einen Chat */
  contextForChat?: Maybe<Context>;
  /** Holt den Kontext für eine Nachricht */
  contextForMessage?: Maybe<Context>;
  /** Checks if a document exists by reference without throwing an error */
  documentExists?: Maybe<Document>;
  /** Fetches the summary (SUMMARY or DETAILED_SUMMARY) of a document */
  documentSummary?: Maybe<ContentNode>;
  draftState?: Maybe<DraftState>;
  /** Liste der offiziellen Dokumente basierend auf Filter und Sortierung */
  filteredDocuments: Array<Document>;
  /** Gets AVV generation statistics for the user's company (for monitoring usage) */
  getAVVStats?: Maybe<AvvStats>;
  /** Gets the most recent AVV document for the user's company */
  getActiveAVV?: Maybe<ActiveAvvResult>;
  /** Gets all AVV document versions for the user's company (audit trail) */
  getAllAVVVersions?: Maybe<Array<Maybe<ActiveAvvResult>>>;
  /** Get processing progress for multiple UpdateItems */
  getMultipleProcessingProgress?: Maybe<Array<Maybe<ProcessingProgress>>>;
  /** Ruft die Newsletter-Einstellungen für den aktuellen Benutzer ab */
  getNewsletterSettings?: Maybe<NewsletterSettings>;
  /** Get current processing progress for an UpdateItem */
  getProcessingProgress?: Maybe<ProcessingProgress>;
  /** Get UpdateItem with detailed progress information */
  getUpdateItemWithProgress?: Maybe<UpdateItemWithProgress>;
  /** Estimates the page cost for graph mode based on active documents **and** current chat history */
  graphModeCostEstimate?: Maybe<Scalars['Int']['output']>;
  /** Indicates which graph index variant will be used (toc-full-req, toc-full, toc, full) */
  graphModeVariant?: Maybe<Scalars['String']['output']>;
  /** Prüft, ob das Unternehmen ein aktives Abonnement hat (basierend auf Geschäftslogik) */
  hasActiveSubscription: Scalars['Boolean']['output'];
  /** Prüft, ob ein Service-Credit für den angegebenen Typ verfügbar ist */
  hasServiceCredit: Scalars['Boolean']['output'];
  /** Invite Link mit Code abrufen */
  inviteLink?: Maybe<InviteLink>;
  /** Get user notification statistics */
  notificationStats?: Maybe<NotificationStats>;
  /** Details eines offiziellen Dokuments (inklusive Content) */
  officialDocument?: Maybe<Document>;
  /** Details eines offiziellen Dokuments anhand seiner Referenz */
  officialDocumentByReference?: Maybe<Document>;
  /** Liste aller offiziellen Dokumente (ohne Content) */
  officialDocuments: Array<Document>;
  /** Nutzerprofil eines anderen Nutzers */
  otherUserProfile: User;
  /** Details zu den Produkten, um Preise und Beschreibungen darzustellen */
  products: Array<Product>;
  /** Ruft den gespeicherten Checkout-Zustand des Benutzers ab (läuft nach 7 Tagen ab) */
  savedCheckoutState?: Maybe<Scalars['JSON']['output']>;
  seatSwapPreview?: Maybe<SeatSwapPreviewPayload>;
  seatUpgradePreview?: Maybe<SeatUpgradePreview>;
  /** Aktuelle Serverzeit (berücksichtigt Test-Clock) */
  serverTime: Scalars['String']['output'];
  serviceJob?: Maybe<ServiceJob>;
  serviceJobs?: Maybe<Array<Maybe<ServiceJob>>>;
  /** Details des aktuellen Abonnements */
  subscription?: Maybe<Subscription>;
  /** Detaillierte Informationen zum aktuellen Abonnement */
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  /** Erweiterte Abonnement-Zustandsinformationen mit Geschäftslogik */
  subscriptionState?: Maybe<SubscriptionState>;
  /** Get taxonomy mapping data filtered by sector/activity/goal */
  taxonomyMapping: Scalars['JSON']['output'];
  /** List of all available taxonomy sectors */
  taxonomySectors: Array<Scalars['String']['output']>;
  /** Get UpdateItem details by ID */
  updateItem?: Maybe<AdminDraftDocument>;
  /** Get user notifications with filtering and pagination - supports legacy frontend */
  userNotifications?: Maybe<NotificationConnection>;
  /** Nutzerprofil */
  userProfile: User;
  /** Prüfen, ob ein Invite Link gültig ist */
  validateInviteLink?: Maybe<Scalars['Boolean']['output']>;
};


export type QueryAdminCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminCompanyFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminCompanySortInput>;
};


export type QueryAdminCompanyByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminContentNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminContentNodesForDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<AdminContentNodeFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminContentNodeSortInput>;
};


export type QueryAdminDocumentByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminDocumentFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminDocumentSortInput>;
};


export type QueryAdminPublishedDraftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminUserByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<AdminUserFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AdminUserSortInput>;
};


export type QueryChatArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatsArgs = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyUploadsArgs = {
  companyId: Scalars['String']['input'];
};


export type QueryContextForChatArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryContextForMessageArgs = {
  messageId: Scalars['ID']['input'];
};


export type QueryDocumentExistsArgs = {
  reference: Scalars['String']['input'];
};


export type QueryDocumentSummaryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDraftStateArgs = {
  category: Scalars['String']['input'];
};


export type QueryFilteredDocumentsArgs = {
  chatMode?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DocumentFilterInput>;
  sort?: InputMaybe<DocumentSortInput>;
};


export type QueryGetMultipleProcessingProgressArgs = {
  updateItemIds: Array<Scalars['String']['input']>;
};


export type QueryGetProcessingProgressArgs = {
  updateItemId: Scalars['String']['input'];
};


export type QueryGetUpdateItemWithProgressArgs = {
  updateItemId: Scalars['String']['input'];
};


export type QueryGraphModeCostEstimateArgs = {
  chatId: Scalars['ID']['input'];
};


export type QueryHasServiceCreditArgs = {
  type?: InputMaybe<ServiceCreditType>;
};


export type QueryInviteLinkArgs = {
  code: Scalars['String']['input'];
};


export type QueryOfficialDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOfficialDocumentByReferenceArgs = {
  reference: Scalars['String']['input'];
};


export type QueryOtherUserProfileArgs = {
  userId: Scalars['ID']['input'];
};


export type QuerySeatSwapPreviewArgs = {
  user1Id: Scalars['ID']['input'];
  user2Id: Scalars['ID']['input'];
};


export type QuerySeatUpgradePreviewArgs = {
  seatsL: Scalars['Int']['input'];
  seatsM: Scalars['Int']['input'];
  seatsS: Scalars['Int']['input'];
  subscriptionId: Scalars['ID']['input'];
};


export type QueryServiceJobArgs = {
  id: Scalars['String']['input'];
};


export type QueryServiceJobsArgs = {
  status?: InputMaybe<ServiceJobStatus>;
  type?: InputMaybe<ServiceCreditType>;
};


export type QueryTaxonomyMappingArgs = {
  activity?: InputMaybe<Scalars['String']['input']>;
  goal?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpdateItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<NotificationFilters>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryValidateInviteLinkArgs = {
  code: Scalars['String']['input'];
};

export type SaveDraftStateInput = {
  category: Scalars['String']['input'];
  payload: Scalars['JSON']['input'];
};

export type SeatDistributionInput = {
  seatsL: Scalars['Int']['input'];
  seatsM: Scalars['Int']['input'];
  seatsS: Scalars['Int']['input'];
};

export type SeatSwapPreviewPayload = {
  __typename?: 'SeatSwapPreviewPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Cost per seat type in cents */
export type SeatUpgradeCostLine = {
  __typename?: 'SeatUpgradeCostLine';
  seatType: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type SeatUpgradePreview = {
  __typename?: 'SeatUpgradePreview';
  breakdown: Array<SeatUpgradeCostLine>;
  grossTotal: Scalars['Int']['output'];
  /** @deprecated Use grossTotal instead */
  netTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
};

/** Repräsentiert einen Service-Credit für einen zusätzlichen Service */
export type ServiceCredit = {
  __typename?: 'ServiceCredit';
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  remainingUses: Scalars['Int']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  type: ServiceCreditType;
  updatedAt: Scalars['String']['output'];
};

/** Typen von Service-Credits die ein Unternehmen erwerben kann */
export enum ServiceCreditType {
  QuickWesentlichkeit = 'QUICK_WESENTLICHKEIT',
  VsmeReport = 'VSME_REPORT',
  WorkshopEsg = 'WORKSHOP_ESG',
  WorkshopKi = 'WORKSHOP_KI'
}

/** Repräsentiert einen Hintergrund-Service-Job (z.B. Quick-Wesentlichkeitsanalyse) */
export type ServiceJob = {
  __typename?: 'ServiceJob';
  companyId: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  estimatedCompletion?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatorId: Scalars['String']['output'];
  inputData: Scalars['JSON']['output'];
  resultData?: Maybe<Scalars['JSON']['output']>;
  resultFiles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: ServiceJobStatus;
  submittedAt: Scalars['String']['output'];
  type: ServiceCreditType;
};

/** Status eines Service-Jobs */
export enum ServiceJobStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Ein Abonnement einer Firma */
export type Subscription = {
  __typename?: 'Subscription';
  company: Company;
  companyId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  seatsL: Scalars['Int']['output'];
  seatsM: Scalars['Int']['output'];
  seatsS: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

/** Informationen über ein Abonnement */
export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Ende der Kulanzfrist */
  gracePeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Ob das Unternehmen Zugriff auf die Plattform hat (basierend auf Geschäftslogik) */
  hasAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  /** Ob das Abonnement abgelaufen ist */
  isExpired: Scalars['Boolean']['output'];
  /** Ob das Abonnement derzeit in der Kulanzfrist ist */
  isInGracePeriod: Scalars['Boolean']['output'];
  isInTrial: Scalars['Boolean']['output'];
  /** Zeitpunkt, zu dem das Seitenkontingent voraussichtlich das nächste Mal aufgefüllt wird */
  nextCreditRefreshAt?: Maybe<Scalars['String']['output']>;
  seatsL: Scalars['Int']['output'];
  seatsM: Scalars['Int']['output'];
  seatsS: Scalars['Int']['output'];
  /** Verfügbare Service-Credits für das Unternehmen */
  serviceCredits: Array<ServiceCredit>;
  status: Scalars['String']['output'];
  /** Typ des Abonnements (bestimmt durch Geschäftslogik) */
  subscriptionType: SubscriptionType;
  trialEnd?: Maybe<Scalars['String']['output']>;
  trialStarted?: Maybe<Scalars['String']['output']>;
};

/** Sitzplatz-Informationen eines Abonnements */
export type SubscriptionSeats = {
  __typename?: 'SubscriptionSeats';
  /** Anzahl L-Sitzplätze */
  L: Scalars['Int']['output'];
  /** Anzahl M-Sitzplätze */
  M: Scalars['Int']['output'];
  /** Anzahl S-Sitzplätze */
  S: Scalars['Int']['output'];
  /** Gesamtanzahl Sitzplätze */
  total: Scalars['Int']['output'];
};

/** Erweiterte Abonnement-Zustandsinformationen mit Geschäftslogik */
export type SubscriptionState = {
  __typename?: 'SubscriptionState';
  /** Ende der aktuellen Abrechnungsperiode */
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Ende der Kulanzfrist */
  gracePeriodEnd?: Maybe<Scalars['String']['output']>;
  /** Ob das Unternehmen Zugriff auf die Plattform hat */
  hasAccess: Scalars['Boolean']['output'];
  /** Ob das Abonnement abgelaufen ist */
  isExpired: Scalars['Boolean']['output'];
  /** Ob das Abonnement derzeit in der Kulanzfrist ist */
  isInGracePeriod: Scalars['Boolean']['output'];
  /** Ob das Abonnement derzeit in der Testphase ist */
  isInTrial: Scalars['Boolean']['output'];
  /** Ob Zahlungen überfällig sind */
  isPastDue: Scalars['Boolean']['output'];
  /** Details für manuell gewährte Abonnements */
  manualSubscription?: Maybe<ManualSubscriptionInfo>;
  /** Verfügbare Sitzplätze */
  seats: SubscriptionSeats;
  /** Status des Abonnements */
  status: Scalars['String']['output'];
  /** Typ des Abonnements */
  subscriptionType: SubscriptionType;
  /** Ende der Testphase */
  trialEnd?: Maybe<Scalars['String']['output']>;
};

/** Status eines Abonnements */
export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  PastDue = 'PAST_DUE',
  Unpaid = 'UNPAID'
}

/** Typen von Abonnements - bestimmt durch Geschäftslogik basierend auf verschiedenen Faktoren */
export enum SubscriptionType {
  FreeTrial = 'FREE_TRIAL',
  ManualGrant = 'MANUAL_GRANT',
  None = 'NONE',
  StripePaid = 'STRIPE_PAID'
}

export type SwapUserSeatsPayload = {
  __typename?: 'SwapUserSeatsPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
  user1?: Maybe<User>;
  user2?: Maybe<User>;
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Aufzeichnung einer ausgeführten Aufgabe */
export type TaskRecord = {
  __typename?: 'TaskRecord';
  /** ID des zugehörigen Chats (falls vorhanden) */
  chatId?: Maybe<Scalars['String']['output']>;
  /** Anzahl der verbrauchten Coins */
  coinsSpent: Scalars['Int']['output'];
  /** ID des Unternehmens */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Erstellungszeitpunkt */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** ID des Benutzers, der die Aufgabe initiiert hat */
  initiatorId?: Maybe<Scalars['String']['output']>;
  /** Zusätzliche Metadaten (z.B. verwendete Dokumente und Anhänge) */
  metadata: Scalars['JSON']['output'];
  /** Anzahl der verbrauchten Seiten */
  pagesSpent: Scalars['Int']['output'];
  /** Typ der Aufgabe */
  type: TaskType;
  /** Letzter Änderungszeitpunkt */
  updatedAt: Scalars['String']['output'];
};

/** Typ einer Aufgabe */
export enum TaskType {
  ChatSummaryGeneration = 'CHAT_SUMMARY_GENERATION',
  DocumentIngestion = 'DOCUMENT_INGESTION',
  MessageGeneration = 'MESSAGE_GENERATION',
  ProfileGeneration = 'PROFILE_GENERATION',
  QuickWesentlichkeit = 'QUICK_WESENTLICHKEIT'
}

/** A unified update containing multiple items (documents, announcements, features, etc.) */
export type Update = {
  __typename?: 'Update';
  category: UpdateCategory;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  managedBy?: Maybe<Scalars['String']['output']>;
  notificationMetrics?: Maybe<NotificationMetrics>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  publishedBy?: Maybe<Scalars['String']['output']>;
  scheduledPublishAt?: Maybe<Scalars['DateTime']['output']>;
  source: UpdateSource;
  statistics?: Maybe<UpdateStatistics>;
  status: UpdateStatus;
  title: Scalars['String']['output'];
  triggerType?: Maybe<Scalars['String']['output']>;
  updateItems: Array<UpdateItem>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Categories of updates in the system */
export enum UpdateCategory {
  Document = 'DOCUMENT',
  Feature = 'FEATURE',
  Integration = 'INTEGRATION',
  Policy = 'POLICY',
  Security = 'SECURITY',
  System = 'SYSTEM'
}

/** Paginated updates */
export type UpdateConnection = {
  __typename?: 'UpdateConnection';
  cursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  nodes: Array<Update>;
  totalCount: Scalars['Int']['output'];
};

/** Input for updating update details */
export type UpdateDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating draft title and description */
export type UpdateDraftDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Status of the system-wide update draft */
export enum UpdateDraftStatus {
  Cancelled = 'CANCELLED',
  Preparing = 'PREPARING',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Ready = 'READY',
  Scheduled = 'SCHEDULED'
}

/** Filters for querying updates */
export type UpdateFilters = {
  categories?: InputMaybe<Array<InputMaybe<UpdateCategory>>>;
  managedBy?: InputMaybe<Scalars['String']['input']>;
  publishedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  publishedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  sources?: InputMaybe<Array<InputMaybe<UpdateSource>>>;
  statuses?: InputMaybe<Array<InputMaybe<UpdateStatus>>>;
};

/** Individual item within an update (document, announcement, feature, etc.) */
export type UpdateItem = {
  __typename?: 'UpdateItem';
  bumpType?: Maybe<BumpType>;
  changeSummary?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemData?: Maybe<Scalars['JSON']['output']>;
  itemType: UpdateItemType;
  previousDocument?: Maybe<Document>;
  previousDocumentId?: Maybe<Scalars['String']['output']>;
  processingStatus: ProcessingStatus;
  update?: Maybe<Update>;
  updateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vaultPath?: Maybe<Scalars['String']['output']>;
};

/** Types of items within an update */
export enum UpdateItemType {
  Custom = 'CUSTOM',
  DocumentAmendment = 'DOCUMENT_AMENDMENT',
  DocumentDelete = 'DOCUMENT_DELETE',
  DocumentNew = 'DOCUMENT_NEW',
  DocumentUpdate = 'DOCUMENT_UPDATE',
  FeatureRelease = 'FEATURE_RELEASE',
  IntegrationChange = 'INTEGRATION_CHANGE',
  MaintenanceNotice = 'MAINTENANCE_NOTICE',
  PolicyUpdate = 'POLICY_UPDATE',
  SecurityUpdate = 'SECURITY_UPDATE',
  SystemAnnouncement = 'SYSTEM_ANNOUNCEMENT'
}

/** UpdateItem with detailed progress information */
export type UpdateItemWithProgress = {
  __typename?: 'UpdateItemWithProgress';
  bumpType?: Maybe<BumpType>;
  changeSummary?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemData?: Maybe<Scalars['JSON']['output']>;
  itemType: UpdateItemType;
  previousDocument?: Maybe<Document>;
  previousDocumentId?: Maybe<Scalars['String']['output']>;
  processingStatus: ProcessingStatus;
  /** Real-time processing progress */
  progress?: Maybe<ProcessingProgress>;
  updateId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vaultPath?: Maybe<Scalars['String']['output']>;
};

/** Source of the update */
export enum UpdateSource {
  AutomaticDetection = 'AUTOMATIC_DETECTION',
  ExternalWebhook = 'EXTERNAL_WEBHOOK',
  ManualAdmin = 'MANUAL_ADMIN',
  ScheduledTask = 'SCHEDULED_TASK'
}

/** Statistics about an update */
export type UpdateStatistics = {
  __typename?: 'UpdateStatistics';
  documentItems: Scalars['Int']['output'];
  processingComplete: Scalars['Int']['output'];
  readyForPublishing: Scalars['Boolean']['output'];
  systemItems: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

/** Status of an update in its lifecycle */
export enum UpdateStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Ready = 'READY',
  Scheduled = 'SCHEDULED'
}

/** User */
export type User = {
  __typename?: 'User';
  /** Chat Einstellungen des Users */
  chatSettings?: Maybe<UserChatSettings>;
  /** Firma des Users */
  company?: Maybe<Company>;
  /** E-Mail des Users */
  email: Scalars['String']['output'];
  /** E-Mail-Verifikationsstatus des Users */
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Name des Users */
  name: Scalars['String']['output'];
  /** Firma, die der User besitzt (falls vorhanden) */
  ownedCompany?: Maybe<Company>;
  /** Seitenkontingent des Users */
  pageQuota?: Maybe<Scalars['Int']['output']>;
  /** Rolle des Users */
  role?: Maybe<UserRole>;
  /** Größe des Users (für Limitierungen) */
  size?: Maybe<UserSize>;
  /** Jobtitel des Users */
  title?: Maybe<Scalars['String']['output']>;
  /** Verbrauchte Seiten des Users */
  usedPages?: Maybe<Scalars['Int']['output']>;
};

export enum UserChatSetting_Language {
  De = 'DE',
  En = 'EN'
}

export enum UserChatSetting_ResponseLength {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT'
}

export enum UserChatSetting_ResponseStyle {
  Casual = 'CASUAL',
  Scientific = 'SCIENTIFIC'
}

export enum UserChatSetting_Verbosity {
  BulletPoints = 'BULLET_POINTS',
  Fluent = 'FLUENT'
}

export type UserChatSettings = {
  __typename?: 'UserChatSettings';
  advancedSettingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<UserChatSetting_Language>;
  responseLength?: Maybe<UserChatSetting_ResponseLength>;
  responseStyle?: Maybe<UserChatSetting_ResponseStyle>;
  showAmendments?: Maybe<Scalars['Boolean']['output']>;
  showOriginals?: Maybe<Scalars['Boolean']['output']>;
  showSummaries?: Maybe<Scalars['Boolean']['output']>;
  verbosity?: Maybe<UserChatSetting_Verbosity>;
};

/** Per-user, per-update notification */
export type UserNotification = {
  __typename?: 'UserNotification';
  acknowledgedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  isAcknowledged: Scalars['Boolean']['output'];
  isDismissed: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  priority: NotificationPriority;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  requiresAction: Scalars['Boolean']['output'];
  update?: Maybe<Update>;
  updateId: Scalars['String']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type UserQuotaInput = {
  pageQuota: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

/** Rolle eines Nutzers innerhalb einer Firma */
export enum UserRole {
  Admin = 'ADMIN',
  Editor = 'EDITOR'
}

/** Größe eines Nutzers (für Limitierungen) */
export enum UserSize {
  L = 'L',
  M = 'M',
  S = 'S'
}
